import axios from "axios";
import { SUBSCRIPTION_ENDPOINTS, API_BASE_URL } from "../constants/apis";
import tokenRefreshService from "./tokenRefresh";

// Subscription service for checking subscription status
class SubscriptionService {
    constructor() {
        this.baseURL = API_BASE_URL;
    }

    // Check if user has an active subscription
    async checkSubscription() {
        try {
            const token = await tokenRefreshService.getValidToken();
            const headers = {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            };

            const response = await axios.get(
                `${this.baseURL}${SUBSCRIPTION_ENDPOINTS.SUBSCRIPTION_CHECK}`,
                { headers }
            );
            return response.data;
        } catch (error) {
            console.error('Error checking subscription:', error);
            throw error;
        }
    }
}

// Create singleton instance
const subscriptionService = new SubscriptionService();

export default subscriptionService;

